module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_50_100.1e0f6486.png";